import { Component, ViewChild, OnInit, ElementRef, AfterViewInit, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ApiService } from 'src/app/api/api.service';
import { GlobalService } from 'src/app/api/global.service';

// PDFTron WebViewer has been removed - this component needs to be updated with an alternative
// declare const WebViewer: any;

@Component({
  selector: 'app-file-editor',
  templateUrl: './file-editor.page.html',
  styleUrls: ['./file-editor.page.scss'],
})
export class FileEditorPage implements OnInit, AfterViewInit {
  @ViewChild('viewer') viewer: ElementRef;

  wvInstance: any;

  @Input() file: any = null;
  @Input() current_folder_guid = '';
  @Input() create_file = false;
  @Input() modal_title = "File Editor";
  @Input() title = '';
  @Input() dataString = '';

  file_type = "";
  document_viewer = null;
  annotation_manager = null;

  constructor(private modalController: ModalController, private apiService: ApiService, public globalService: GlobalService) { }

  ngOnInit() {
    if (this.file) this.file_type = this.globalService.GetFileType(this.file.file_name);

    // Show error message that this component needs updating
    this.globalService.presentToastMessage(
      'File editor component needs to be updated. PDFTron has been removed from this project.',
      false
    );
  }

  ngAfterViewInit(): void {
    // PDFTron WebViewer code has been removed
    // This component needs to be reimplemented with an alternative library
    console.warn('File editor component is disabled - PDFTron WebViewer has been removed');

    /*
    // OLD PDFTron CODE - REMOVED
    WebViewer({
      path: '../../wv-resources/lib',
      licenseKey: 'Nd0mC6snK1xv9jaivmkL',
      enableOfficeEditing: true,
      extension: this.file_type,
      initialDoc: this.file ? this.apiService.GetDownloadURL(this.file) : null,
      ...
    });
    */
  }

  Close() {
    this.modalController.dismiss();
  }

  Dismiss() {
    this.modalController.dismiss();
  }

  Create() {
    this.globalService.presentToastMessage(
      'File editor is disabled. Please update this component with an alternative to PDFTron.',
      false
    );
  }

  async SaveFile() {
    this.globalService.presentToastMessage(
      'File editor is disabled. Please update this component with an alternative to PDFTron.',
      false
    );
  }
}